<template>
  <div class="gray-text">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "GrayText"
}
</script>
